import { Component, OnInit, Input } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth'
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-forum-list',
  templateUrl: './forum-list.component.html',
  styleUrls: ['./forum-list.component.scss'],
  providers: [AngularFireDatabase, AngularFireAuth]
})
export class ForumListComponent implements OnInit {
  @Input() recent : boolean = false;
  isLogged: boolean = false;
  items: Observable<any[]>;


  constructor(private db: AngularFireDatabase,
              private auth: AngularFireAuth) {
  }

  ngOnInit() {
    this.auth.auth.onAuthStateChanged(user => {
      if(user) {
        this.isLogged = true
        this.getItems(true)
      } else {
        this.getItems(false)
      }
    })
  }

  getItems(allItems: boolean) {
    let itemsRef = this.db.list('discussions',
    ref => ref.orderByChild('inactive').equalTo(null).limitToLast(10));
    if(this.recent && !allItems) {
      itemsRef = this.db.list('discussions',
                ref => ref.orderByChild('date').limitToLast(3))
    }
    this.items = itemsRef.snapshotChanges().map(changes => {
      return changes.map(c => ({ key: c.key, ...c.payload.val() })).slice().reverse();
    });
  }
}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/forum/forum-list/forum-list.component.ts